export const POEMS = [
  {
    id: "1",
    title: "कह दो कि है प्रेम नही",
    paragraphs: [
      "वसुंधरा के चहुँ ओर,\nशशि का गमन करना\nअपनी आभा से,\nरजनी का तम हरना \n",
      "नित्य-प्रति प्रभाकर भारी\nअतएव तो यह प्रेम नही\nहाँ नही प्रेम यदि तो\nकह दो कि है प्रेम नही \n",
      "दोनों की पृथक प्रकृति पर\nपरस्पर दोनों का चलना\nएक अह्न का धीर धर कर\nपुनः रात्रि में मिलना \n",
      "यही प्रेम की परिकाष्ठा\nयही प्रेम का सार है\nनही जाने तो सूक्ष्म बहुत\nजान लिया तो संसार है \n"
    ]
  },
  {
    id: "2",
    title: "और अंत में मैं क्या देखता हूँ",
    paragraphs: [
      "और अंत में मैं क्या देखता हूँ \nकि भूतकाल को \nबदल सकने का विचार,\nवर्तमान के साथ किया हुआ \nअन्याय है\n",
      "ऐसी कल्पना करना कि \nहम भविष्य बदल सकते है \nकुछ नही केवल\nएक हास्यास्पद कथन है\n",
      "मन का चंचल होना\nइस बात का प्रमाण है \nकि इस चराचर जगत में \nकुछ भी स्थिर नहीं ।\nअस्थिरता ही इस सृष्टि का \nसर्वोत्तम गुण है।\n",
      "परिवर्तन जो पूर्वनिर्धारित है\nजो पूर्वनियोजित है \nजो नियति है \nउसे बदल सकने का भाव ही\nजीवन है !!\n"
    ]
  },
  {
    id: "3",
    title: "स्वयं की स्थिरता,",
    paragraphs: [
      "स्वयं की स्थिरता, ठहराव से,\nजल अपने उपयोग\nमें आने की प्रायिकता \nखो देता है\n",
      "ठहराव जीवन के \nमहत्व को निम्न \nकरता जाता है\n",
      "कहीं जाना नहीं है,\nपर जहाँ हो वहाँ से \nनिकलने का विचार\nनिरन्तरता को जन्म देता है\n",
      "मन की यही चंचलता\nकुछ करते रहने का\nमार्ग प्रदर्शित करती है\n",
      "पृथ्वी अपने अक्ष पर,\nसूर्य अपने अक्ष पर,\nघूमने के साथ साथ,\nनिरन्तर चलते रहते है\n",
      "मनुष्य प्रकृति का ही भाग है\nतुम देखो, इन पुष्पो को\nऔर मुझे\nहम एक से हैं\n",
      "अतएव कुछ करते रहिए!!\nनिरन्तर चलते रहिए!!\n"
    ]
  },

  {
    id: "4",
    title: "स्वप्न हमारे, हमारी कहानियाँ",
    paragraphs: [
      "स्वप्न हमारे, हमारी कहानियाँ,\n अपूर्ण है! अपूर्ण है तो क्यूँ है ?\n",
      "बाल्यावस्था में, निद्रा से पूर्व\nजो कहानियाँ सुनी थी ।\nउन कहानियों का सफल अंत \nहमसे हमारी निद्रा ने छीन लिया\n",
      "कहीं ऐसा न हो\nकि हमारे स्वप्न \nमात्र स्वप्न ही रह जाए\nऔर हमारा जीवन \nकेवल निद्रा\n",
      "इसीलिए अनिवार्य है\nउचित मापदंड\n",
      "निद्रा केवल दो प्रहर हो\nतीन प्रहर हो काम\nदो प्रहर संसार जगत को\nएक प्रहर प्रभु नाम !!\n"
    ]
  },

  {
    id: "5",
    title: "शिक्षण से दरिद्रता हटाई जा सकती है",
    paragraphs: [
      "शिक्षण से दरिद्रता हटाई जा सकती है\n पुस्तकों से अपेक्षा लगाई\n जा सकती है\n",
      "ज्ञान से जीता जा सकता है जगत को\nबुद्धि से दुनिया हराई\n जा सकती है\n",
      "काम में आ सकता है खोटा सिक्का\nखोटी वस्तु भी चलाई\n जा सकती है\n",
      "गंतव्य तक यदि साथ नही चल सकते \nगंतव्य तक राह दिखाई\n जा सकती है\n",
      "पर्वत उठाया जा सकता है करो में\nसागर में शिलाएं तैराई\n जा सकती है\n",
      "पिता से जिन बातों का भय रहता है\nमाँ को वो बातें बताई\n जा सकती है\n",
      "घर को घर मात्र परिवार करता है\nऐसे तो दीवारें उठाई\n जा सकती है\n",
      "धर्म क्या है सद्गुणों का परिचय तो\nसबको यह सूक्ति पढ़ाई\n जा सकती है\n"
    ]
  },

  {
    id: "6",
    title: "कहानी के अंत तक",
    paragraphs: [
      "कहानी के अंत तक,\n हो भी जाए ठीक सब\nमैं कहानी के अंत की\nप्रतीक्षा ही क्यों करूँ\n",
      "मैं तो चाहूँ बन जाऊँ\nअपनी कहानी का \nस्वयं ही कहानीकार\nऔर कभी न लिखूँ \nकिसी प्रकार का दुःख\nजो अंत में जाकर मिटे\nजीवन एक बार का\nमिला इसे जियूँ सही से\nमन की करूँ निर्भय रहूँ\n",
      "अंत में रहेगा पछतावा\nहर उस क्रिया का \nजो अधूरी रह गई \nजिसे आपने चाहा परंतु\nछोड़ दिया अंत के लिए\nऔर वो पूर्ण ही नही हुई\n",
      "प्रतिपल जन्म लेते है\nअंत और आरम्भ\nआरम्भ का साथ छोड़\nमैं अंत को क्यों चुनु\nमैं अंनत तक अंत की\nप्रतीक्षा ही क्यों करूँ\n"
    ]
  },

  {
    id: "7",
    title: "ज्ञात होते हुए भी",
    paragraphs: [
      "ज्ञात होते हुए भी,\n कि बच्चा मेले से \nक्या मांग ले\nउतना सामर्थ्य होगा \nया निराशा होगी\nपिता मेला दिखाने \nले जाते हैं\n",
      "और ईश्वर भी \nइस दृश्य को \nसुखद बनाने हेतु \nउसी ईच्छा का संचार \nबच्चे में करते हैं \nजो पिता के योग में है\n",
      "ये सृष्टि उनकी है \nऔर वो कभी \nकिसी पिता,\nया बच्चे को \nनिराश नहीं होने देंगे।\n"
    ]
  },

  {
    id: "8",
    title: "एकपक्षीय प्रेम निरर्थक है",
    paragraphs: [
      "गणित में भी '१'\nएक विषम संख्या है\n",
      "इतना कठिन विषय भी \nप्रेम को कितनी\nसरलता से समझाता है\n"
    ]
  },

  {
    id: "9",
    title: "",
    paragraphs: [
      "मन का चंचल होना\n इस बात का प्रमाण है \nकि इस चराचर जगत में कुछ भी स्थिर नहीं ।\nअस्थिरता ही इस सृष्टि का सर्वोत्तम गुण है।\n"
    ]
  },
  
  {
    id: "10",
    title: "",
    paragraphs: [
      "समाज पुरुष को इतना विभाजित कर सकता है\nकि उसके टुकड़े\nअणु के सौंवे भाग से \nभी सूक्ष्म लगेंगे\nपुनः सबको एकत्रित करके\nजोड़ना सम्भव नहीं\nये एकीकरण का कार्य\nमात्र स्त्री कर सकती है\n",
      "परन्तु इसके विपरीत यदि\nविभाजन स्त्री द्वारा हुआ है\nतो पूरा समाज मिलकर भी\nपुनः उस पुरुष को नही जोड़ सकता!!\n"
    ]
  },
  {
    id: "11",
    title: "इच्छाओं का कोई पार नही",
    paragraphs: [
      "इच्छाओं का कोई पार नही,\n मन पर किसी का वश नही\n",
      "सत्य का ज्ञान होते हुए भी\nइच्छा का जन्म होता है\nऔर वही प्रथम चरण है\nकल्पना का वास्तविक होने में\n",
      "जाते हुए पलट कर देखना\nपुनः मिलने की इच्छा को दर्शाता है\nइच्छा जो प्रबल है\nदोनों पक्षो की ओर से ।\n",
      "इच्छाएँ आपको सदैव\nजीवित रखने के लिए\nअतिआवश्यक है,\nभले वो इच्छा मृत्यु की ही\nक्यो न हो !!\n"
    ]
  }
];
